import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { Portal } from '~/features/common';
import WRButton from '../widget/wr-button';

export const MODAL_BASE_CLASS = 'my-modal';

const ExitButton = ({ className, onClick }) => (
  <div className={className} onClick={onClick} role="button" tabIndex={0}>
    <img src="/images/cross_icon_black.svg" width="12px" height="12px" alt="Close modal" />
  </div>
);

/** @deprecated prefer `import { Modal } from '@workramp/ui';` */
const ModalFunctional = ({
  cancelButtonTitle,
  children,
  disableSaveOnEnter,
  dontShowCancelButton,
  dontShowSaveButton,
  dontShowHeader,
  extraButtons,
  onClose = () => {},
  onSave = () => {},
  saveButtonTitle,
  show,
  showCloseButton,
  title,
  wider,
  wrapHeader,
  isSaveDisabled = false,
}) => {
  const [saveDisabled, setSaveDisabled] = useState(isSaveDisabled);
  const modalRef = useRef();
  const TRANSLATED_DEFAULT_MODAL_CANCEL = I18n.t('common.application.cancel');
  const TRANSLATED_DEFAULT_MODAL_SAVE = I18n.t('common.application.save');

  const onSaveCallback = (e) => {
    e.preventDefault();

    setSaveDisabled(true);

    onSave(() => {
      setSaveDisabled(false);
    });
  };

  const onCloseCallback = (e) => {
    e.preventDefault();

    onClose();
  };

  const onKeydownCallback = (e) => {
    if (show && !disableSaveOnEnter && e.keyCode == 13) {
      onSaveCallback(e);
    }
  };

  useEffect(() => {
    setSaveDisabled(isSaveDisabled);
  }, [isSaveDisabled]);

  useEffect(() => {
    window.addEventListener('keydown', onKeydownCallback);

    return () => {
      window.removeEventListener('keydown', onKeydownCallback);
    };
  });

  useEffect(() => {
    $(modalRef.current).on('hidden.bs.modal', onCloseCallback);

    if (show) {
      $(modalRef.current).modal('show');
    } else {
      $(modalRef.current).modal('hide');
    }

    return () => {
      $(modalRef.current).off('hidden.bs.modal');
    };
  }, [show]);

  const modalStyleClass = wider ? ' wider' : '';
  const modalClass = `${MODAL_BASE_CLASS} modal fade grey-5 editable ${modalStyleClass}`;

  return (
    <Portal>
      <div className={modalClass} ref={modalRef} tabIndex={-1} role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            {dontShowHeader ? (
              ''
            ) : (
              <ModalHeader wrapHeader={wrapHeader} className="my-modal-header flex">
                <div className="hide-overflow mrl">{title}</div>
                <HeaderExitButton onClick={onCloseCallback} />
              </ModalHeader>
            )}
            {dontShowHeader && showCloseButton && <NonHeaderExitButton onClick={onCloseCallback} />}
            <div className="my-modal-body">{children}</div>
            <div className="my-modal-footer text-right">
              {extraButtons}
              {dontShowCancelButton ? (
                ''
              ) : (
                <WRButton white className="mlm" onClick={onCloseCallback}>
                  {cancelButtonTitle || TRANSLATED_DEFAULT_MODAL_CANCEL}
                </WRButton>
              )}
              {dontShowSaveButton ? (
                ''
              ) : (
                <WRButton className="mlm" onClick={onSaveCallback} disabled={saveDisabled}>
                  {saveButtonTitle || TRANSLATED_DEFAULT_MODAL_SAVE}
                </WRButton>
              )}
            </div>
          </div>
        </div>
      </div>
    </Portal>
  );
};

export default ModalFunctional;

const ModalHeader = styled.div`
  ${(props) =>
    props.wrapHeader
      ? `
      height: auto;
      padding-top: 18.5px;
      padding-bottom: 18.5px;

      .hide-overflow {
        overflow: visible;
        white-space: normal;
      }
    `
      : ''}
`;

const HeaderExitButton = styled(ExitButton).attrs({ className: 'flex-1 text-right' })`
  cursor: pointer;
`;

const NonHeaderExitButton = styled(ExitButton)`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 30px;
  height: 30px;
  width: 30px;
  right: 20px;
  top: 20px;
  cursor: pointer;

  img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 50%;
  }

  &:hover {
    background: #f2f4f7;
  }
`;
